import classNames from "classnames";
import styles from "./slider-v2.module.scss";

interface Props {
  onClick: () => void;
  arrowType: string;
  showArrowOnHover: boolean;
}

function SliderArrow(props: Props) {
  const { onClick, arrowType, showArrowOnHover } = props;

  return (
    <button
      type="button"
      className={classNames(styles.base_arrow, {
        [styles.prev_arrow]: arrowType === "prev",
        [styles.next_arrow]: arrowType === "next",
        [styles.slider_arrow_hover]: showArrowOnHover,
      })}
      onClick={onClick}
    >
      {arrowType === "prev" ? <>&#10094;</> : <>&#10095;</>}
    </button>
  );
}

export default SliderArrow;
